<script>
import Divider from 'primevue/divider';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export default {
  name: 'NavBar',
  components: { Divider, FontAwesomeIcon },
  emits: [],
  mixins: [],
  props: {},
  data() {
    return {
      activePage: 'home',
    };
  },
  mounted() {},
  methods: {
    isActive(link) {
      return link === this.$route.name;
    },
  },
  computed: {},
};
</script>

<template>
  <div class="rounded-t-2xl bg-gray-100">
    <div class="flex justify-between px-7">
      <RouterLink
          :to="{ name: 'home' }"
          @click="this.activePage = 'home'"
          :class="isActive('home') ? 'active' : null"
          class="nav-link">
        <font-awesome-icon icon="fa-home" class="icon"/>
      </RouterLink>

      <RouterLink
          :to="{ name: 'stats' }"
          @click="this.activePage = 'stats'"
          :class="isActive('stats') ? 'active' : null"
          class="nav-link">
        <font-awesome-icon icon="fa-chart-simple" class="icon"/>
      </RouterLink>

      <RouterLink
          :to="{ name: 'support' }"
          @click="this.activePage = 'support'"
          :class="isActive('support') ? 'active' : null"
          class="nav-link">
        <font-awesome-icon icon="fa-headset" class="icon"/>
      </RouterLink>

      <RouterLink :to="{ name: 'settings' }" @click="this.activePage = 'settings'"
                  :class="isActive('settings') ? 'active' : null" class="nav-link">
        <font-awesome-icon icon="fa-user" class="icon"/>
      </RouterLink>
    </div>
  </div>
</template>

<style scoped>
.nav-link {
  @apply py-5 px-4
}

.icon {
  @apply fill-slate-700 w-6 h-6 text-2xl ;}

/*noinspection CssUnusedSymbol Used dynamically */
.active {
  @apply border-t-2 border-t-slate-700;
}

</style>
